import { motion } from "framer-motion";
import { useLightbox } from "@/components/Lightbox";
import { useSlowFactor } from "@/hooks/useSlowFactor";
import { useLanguage } from "@/i18n/LanguageContext";

const images = [
  {
    url: "https://customer-assets.emergentagent.com/job_boost-shop-pro/artifacts/erhz4y1t_%D1%80%D0%B5%D0%B4%D0%B0%D0%BA%D1%82%D0%B8%D1%80%D0%B0%D0%BD%D0%B0.JPG",
    alt: "Ремонтиран биturbo компресор след настройка",
    span: "sm:col-span-2 sm:row-span-2",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_boost-shop-pro/artifacts/agxwy1qw_IMG_4956%20%D1%80%D0%B5%D0%B4%202.JPG",
    alt: "Ремонтиран турбокомпресор с актуатор",
    span: "",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_boost-shop-pro/artifacts/9avn7q0f_IMG_4950%20%D1%80%D0%B5%D0%B4%D0%B0%D0%BA%D1%82%D0%B8%D1%80%D0%B0%D0%BD%D0%B0.JPG",
    alt: "Турбокомпресор с колектор и VNT актуатор",
    span: "",
    dim: true,
  },
  {
    url: "https://customer-assets.emergentagent.com/job_boost-shop-pro/artifacts/k249czoq_IMG_2529%20%D1%80%D0%B5%D0%B4%D0%B0%D0%BA%D1%82%D0%B8%D1%80%D0%B0%D0%BD%D0%B0.JPG",
    alt: "Турбокомпресор с колектор — цял изглед",
    span: "",
    dim: true,
    mob: true,
  },
  {
    url: "https://customer-assets.emergentagent.com/job_boost-shop-pro/artifacts/w89pr7jg_IMG_3393%20%D1%80%D0%B5%D0%B4%D0%B0%D0%BA%D1%82%D0%B8%D1%80%D0%B0%D0%BD%D0%B0.JPG",
    alt: "Турбокомпресор с колектор и актуатор",
    span: "",
    dim: true,
    mob: true,
  },
  {
    url: "https://customer-assets.emergentagent.com/job_boost-shop-pro/artifacts/hw8tcara_IMG_6968%20%D1%80%D0%B5%D0%B4%D0%B0%D0%BA%D1%82%D0%B8%D1%80%D0%B0%D0%BD%D0%B0.JPG",
    alt: "Комплект турбокомпресори в сервиза",
    span: "",
    dim: true,
    mob: true,
  },
  {
    url: "https://customer-assets.emergentagent.com/job_boost-shop-pro/artifacts/s9kwizlz_IMG_6969%20%D1%80%D0%B5%D0%B4%D0%B0%D0%BA%D1%82%D0%B8%D1%80%D0%B0%D0%BD%D0%B0.JPG",
    alt: "Биturbo система с компресорни колела",
    span: "sm:col-span-2",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_boost-shop-pro/artifacts/61v04i54_IMG_4041%20%D1%80%D0%B5%D0%B4%D0%B0%D0%BA%D1%82%D0%B8%D1%80%D0%B0%D0%BD%D0%B0.JPG",
    alt: "Турбинно колело в корпуса отблизо",
    span: "",
  },
];

export const Gallery = () => {
  const { open } = useLightbox();
  const slow = useSlowFactor();
  const { t } = useLanguage();
  return (
    <section id="gallery" data-testid="gallery-section" className="py-16 sm:py-24 lg:py-32 carbon-panel">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-14">
          <p className="text-sm font-bold uppercase tracking-[0.25em] text-red-500 mb-4">{t.gallery.eyebrow}</p>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold uppercase tracking-tight leading-tight text-white">
            {t.gallery.heading}
          </h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 grid-flow-dense gap-1 auto-rows-[180px] sm:auto-rows-[220px]">
          {images.map((img, i) => (
            <motion.div
              key={i}
              data-testid={`gallery-img-${i}`}
              initial={{ opacity: 0, scale: 0.96 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 * slow, delay: i * 0.08 * slow }}
              onClick={() => open(img.url, img.alt)}
              className={`relative overflow-hidden group photo-frame cursor-pointer ${img.span}`}
            >
              <img
                src={img.url}
                alt={img.alt}
                className={`w-full h-full object-cover group-hover:scale-105 transition-all duration-500 ${img.dim ? (img.mob ? "brightness-100 sm:brightness-90" : "brightness-90") : "brightness-125"} opacity-95 group-hover:opacity-100`}
              />
              <div className="absolute inset-0 bg-red-600/0 group-hover:bg-red-600/10 transition-colors duration-500" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
